import { useState } from "react";
import { toast } from "sonner";
import { useLanguage } from "@/contexts/LanguageContext";
import { submitContact } from "@/lib/api";

export default function Contact() {
  const { t } = useLanguage();
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    setSending(true);
    try {
      await submitContact({
        name: String(data.get("name") || ""),
        email: String(data.get("email") || ""),
        message: String(data.get("message") || ""),
      });
      form.reset();
      toast.success(t.contact.success);
    } catch {
      toast.error(t.contact.error);
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contatto" className="py-24 px-6 max-w-4xl mx-auto" data-testid="contact-section">
      <div className="text-center mb-12">
        <span className="text-xs font-mono-code text-[#E2C079] uppercase tracking-widest block mb-2">{t.contact.eyebrow}</span>
        <h2 className="font-serif-didot text-3xl text-white">{t.contact.title}</h2>
        <p className="text-xs text-white/60 mt-2 font-mono-code" data-testid="contact-direct-email">{t.contact.direct}</p>
      </div>

      <form
        className="space-y-4 rounded border border-white/10 bg-[#0f1b29]/40 p-6 md:p-8"
        onSubmit={handleSubmit}
        data-testid="contact-form"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="contact-name" className="block text-[11px] font-mono-code text-white/70 uppercase mb-1">{t.contact.nameLabel}</label>
            <input
              id="contact-name"
              name="name"
              type="text"
              required
              minLength={2}
              data-testid="contact-name-input"
              className="w-full bg-[#0b131e] border border-white/20 p-3 text-xs text-white focus:border-[#E2C079] outline-none"
            />
          </div>
          <div>
            <label htmlFor="contact-email" className="block text-[11px] font-mono-code text-white/70 uppercase mb-1">{t.contact.emailLabel}</label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              data-testid="contact-email-input"
              className="w-full bg-[#0b131e] border border-white/20 p-3 text-xs text-white focus:border-[#E2C079] outline-none"
            />
          </div>
        </div>
        <div>
          <label htmlFor="contact-message" className="block text-[11px] font-mono-code text-white/70 uppercase mb-1">{t.contact.messageLabel}</label>
          <textarea
            id="contact-message"
            name="message"
            rows={4}
            required
            minLength={5}
            data-testid="contact-message-input"
            className="w-full bg-[#0b131e] border border-white/20 p-3 text-xs text-white focus:border-[#E2C079] outline-none"
          ></textarea>
        </div>
        <button
          type="submit"
          disabled={sending}
          data-testid="contact-submit-button"
          className="w-full py-3.5 border border-[#E2C079] text-[#E2C079] font-mono-code text-xs uppercase tracking-widest hover:bg-[#E2C079] hover:text-[#0b131e] transition-colors duration-300 disabled:opacity-60"
        >
          {sending ? t.contact.sending : t.contact.submit}
        </button>
      </form>
    </section>
  );
}
